module.exports = __webpack_public_path__ + "img/device_cover_d.de05b5fa.png";